module.exports = __webpack_public_path__ + "img/header-engagementRingsPrincess.5f16dda.webp";